function updateShippingText() {
  const lang = document.documentElement.lang || 'en';
  moment.locale(lang);

  function addBusinessDays(startDate, daysToAdd) {
    let addedDays = 0;
    let date = startDate.clone();
    while (addedDays < daysToAdd) {
      date.add(1, 'days');
      if (date.isoWeekday() !== 6 && date.isoWeekday() !== 7) { // esclude sabato e domenica
        addedDays++;
      }
    }
    return date;
  }

  const today = moment();
  const dateMin = addBusinessDays(today, 7);
  const dateMax = addBusinessDays(today, 10);

  const shippingText = lang === 'it' ? 
    `Se ordini oggi lo spediremo fra <strong>${dateMin.format('dddd D MMMM')}</strong> e <strong>${dateMax.format('dddd D MMMM')}</strong>` :
    `If you order today we will ship on <strong>${dateMin.format('dddd D MMMM')}</strong> - <strong>${dateMax.format('dddd D MMMM')}</strong>`;

  const shippingTextEl = document.getElementById('shippingText');
  if (shippingTextEl) shippingTextEl.innerHTML = shippingText;
}
